import { Dispatch, SetStateAction } from 'react'

type ObserverCallback<DataType extends any = any> = (
  data: DataType
) => void | Dispatch<SetStateAction<DataType>>

export default class Observer {
  private readonly observers: Record<string, ObserverCallback[]>

  constructor() {
    this.observers = {}
  }

  subscribe<CallbackArg>(message: string, func: ObserverCallback<CallbackArg>) {
    if (this.observers[message]) {
      this.observers[message].push(func)
    } else {
      this.observers[message] = [func]
    }
  }

  unsubscribe(message: string, func: () => void) {
    if (!this.observers[message]) return
    if (this.observers[message].length === 1) {
      delete this.observers[message]
      return
    }
    this.observers[message] = this.observers[message].filter(
      (subscriber) => subscriber !== func
    )
  }

  unsubscribeMessage(message: string | string[]) {
    if (Array.isArray(message)) {
      message.map((mes) => this.unsubscribeMessage(mes))
      return
    }

    if (!this.observers[message]) return
    delete this.observers[message]
  }

  notify(message: string, data?: unknown) {
    if (this.observers[message]) {
      this.observers[message].forEach((observer) => observer(data))
    }
  }
}
